import React from 'react'
import styled from '@emotion/styled'

import { grayLight30, grayDark40 } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import { FlexRowDiv, AnchorButton } from '../generic/Basics'
import FAQModal from '../generic/FAQModal'

const KbbIcoSvg = __PATH_PREFIX__ + '/Landing/KBBICO-Logo-rgb.svg'
const KbycSvg = __PATH_PREFIX__ + '/KBYC-Logo.svg'

export default ({ setShowModal, updateGlobalState, dealerIsDirectToKBBv2, isKbycDealer }) => {
  return (
    <>
      <StyledHeader>
        <StyledICODiv>
          {isKbycDealer && <StyledImg data-testid={`kbb-header-logo`} itemProp="image" src={KbycSvg} alt="Kelley Buys Your Car" />}
          {!isKbycDealer && <StyledImg data-testid={`kbb-header-logo`} itemProp="image" src={KbbIcoSvg} alt="KBB.com Instant Cash Offer" />}
        </StyledICODiv>
        <LinkDiv>
          <StyledButton
            data-testid={`oc-btn-faq`}
            onClick={() => {
              updateGlobalState({ fireAnalytics: 'icoheader_cta_faq' })
              setShowModal('FAQ')
            }}>
            FAQ
          </StyledButton>
          <StyledLink
            data-testid={`oc-btn-email`}
            href="mailto:instantcashoffer@kbb.com"
            target={BrowserUtils.isIframe() ? '_parent' : '_self'}
            onClick={() => updateGlobalState({ fireAnalytics: 'icoheader_cta_email' })}>
            Email
          </StyledLink>
          <StyledLink
            data-testid={`oc-btn-call`}
            href={dealerIsDirectToKBBv2 ? 'tel:513-572-1181' : 'tel:1-866-559-5268'}
            target={BrowserUtils.isIframe() ? '_parent' : '_self'}
            onClick={() => updateGlobalState({ fireAnalytics: 'icoheader_cta_call' })}>
            Call
          </StyledLink>
          <StyledLink
            data-testid={`oc-btn-print`}
            onClick={() => {
              if (BrowserUtils.isBrowser) window.print()
            }}>
            Print
          </StyledLink>
        </LinkDiv>
      </StyledHeader>
      <FAQModal setShowModal={setShowModal} />
    </>
  )
}

const StyledHeader = styled(FlexRowDiv)`
  justify-content: space-between;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 8px;
  border-bottom: 6px solid ${grayLight30};
  @media print {
    display: none;
  }
`
const LinkDiv = styled(FlexRowDiv)`
  font-size: 14px;
`
const StyledButton = styled(AnchorButton)`
  text-decoration: none;
  border-right: 1px solid black;
  :last-child {
    border: none;
  }
  cursor: pointer;
  padding: 0 8px;
  color: ${grayDark40};
`
const StyledLink = styled.a`
  text-decoration: none;
  border-right: 1px solid black;
  :last-child {
    border: none;
  }
  cursor: pointer;
  padding: 0 8px;
  color: ${grayDark40};
  :hover {
    text-decoration: underline;
  }
`
const StyledICODiv = styled.div`
  width: 165px;
  display: block;
`
const StyledImg = styled.img`
  max-width: 160px;
`
